import Image from "next/image";

import { Radio } from "~/components/Radio";
import { Text } from "~/components/Text";
import classNames from "classnames";
import { useStoreCart } from "~/pages/cart/StoreCart/useStoreCart";

export type CarrierCode = "pdk" | "gls" | "bring";

type CarrierProps = {
  name: string;
  code: CarrierCode;
  logoPath: string;
  color?: string;
  isActive?: boolean;
  onSelectCarrier: (value: CarrierCode) => void;
};

const CarrierOption = ({
  name,
  code,
  logoPath,
  isActive,
  onSelectCarrier,
}: CarrierProps) => {
  return (
    <Radio
      onChange={() => onSelectCarrier(code)}
      className="!flex flex-col"
      groupName="carriers"
      id={code}
      checked={isActive}
      checkmarkClassName="!static mt-4"
    >
      <Image width={80} height={80} src={logoPath} alt={name} />
    </Radio>
  );
};

type Props = { className?: string };

export const CarrierSelector = ({ className }: Props) => {
  const { carrierCode, setSavedValues } = useStoreCart();

  const onSelectCarrier = (value: CarrierCode) => {
    setSavedValues((prev) => ({ ...prev, carrierCode: value }));
  };

  const getSharedProps = (carrier: CarrierCode) => {
    return {
      code: carrier,
      onSelectCarrier,
      isActive: carrierCode === carrier,
    };
  };

  return (
    <div className={classNames(className)}>
      <Text>Vælg leverandør</Text>
      <div className="mt-4 flex gap-2">
        <CarrierOption
          {...getSharedProps("pdk")}
          name="PostNord"
          logoPath="/assets/images/postnord.png"
        />
        <CarrierOption
          {...getSharedProps("gls")}
          name="GLS"
          logoPath="/assets/images/gls.png"
        />
        <CarrierOption
          {...getSharedProps("bring")}
          name="Bring"
          logoPath="/assets/images/bring.png"
        />
      </div>
    </div>
  );
};
